// extracted by mini-css-extract-plugin
export default {"errorDiv":"Error_errorDiv__PXkPd","NotFound":"Error_NotFound__4VANY"};